const localStorageKey = 'storeeel_media_view';

export const mediaViewRepository = {
  set(mediaId, campaignId, groupId = null, mediaAssetType = null) {
    const key = (groupId === null || groupId === undefined || groupId === '')
      ? `${mediaId}__${campaignId}`
      : `${mediaId}__${campaignId}__${groupId}`;

    const existing = JSON.parse(localStorage.getItem(localStorageKey) || "{}");

    existing[key] = {
      mediaId,
      campaignId,
      groupId: (groupId === undefined ? null : groupId),
      mediaAssetType: (mediaAssetType === undefined ? null : mediaAssetType)
    };

    localStorage.setItem(localStorageKey, JSON.stringify(existing));
  },

  getAllValid() {
    const result = {};

    try {
      const data = JSON.parse(localStorage.getItem(localStorageKey) || "{}");

      Object.entries(data).forEach(([key, info]) => {
        result[key] = info;
      });

      return result;
    } catch {
      return {};
    }
  },
  removeExpired() {
    // 期限なし運用のため、互換用に残しつつ何もしない
  },
  removeByCampaignId(campaignId) {
    const data = JSON.parse(localStorage.getItem(localStorageKey) || "{}");
    const updatedKeys = Object.keys(data).filter(key =>
      key.endsWith(`__${campaignId}`) || key.includes(`__${campaignId}__`)
    );

    if (updatedKeys.length > 0) {
      updatedKeys.forEach(key => delete data[key]);
      localStorage.setItem(localStorageKey, JSON.stringify(data));
    }
  },
  remove(mediaId, campaignId, groupId = null) {
    const data = JSON.parse(localStorage.getItem(localStorageKey) || "{}");
    const key = (groupId === null || groupId === undefined || groupId === '')
      ? `${mediaId}__${campaignId}`
      : `${mediaId}__${campaignId}__${groupId}`;

    if (key in data) {
      delete data[key];
      localStorage.setItem(localStorageKey, JSON.stringify(data));
    }
  }
};
